module.exports = __webpack_public_path__ + "static/media/Fooddelivery.ff57fede.mp4";